import { Container } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { ActivityLogsNewValues } from "@saleor/permissionGroups/utils/activityLogsNewValues";
import moment from "moment-timezone";
import React from "react";

const useStyles = makeStyles(
  theme => ({
    bullet: {
      backgroundColor: "#002972",
      borderRadius: "50%",
      height: "4px",
      width: "4px"
    },
    card: {
      marginBottom: theme.spacing(3),
      marginLeft: theme.spacing(3),
      position: "relative"
    },
    cardContent: {
      "&:last-child": {
        padding: 16
      },
      boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.05)",
      display: "flex",
      justifyContent: "space-between"
    },
    date: {
      color: "#494E56",
      fontSize: "16px",
      fontWeight: 600
    },
    dot: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "100%",
      height: 10,
      left: -29.5,
      position: "absolute",
      top: 10,
      width: 10
    },
    root: {
      position: "relative"
    },
    status: {
      color: "#002972",
      fontSize: "16px",
      fontWeight: 600
    },
    userEmail: {
      color: "#494E56",
      fontSize: "14px",
      fontWeight: 400
    },
    userTypeCode: {
      color: "#002972",
      fontSize: "16px",
      fontWeight: 600
    }
  }),
  { name: "TimelineNewValues" }
);

interface TimelineNewValuesProps {
  date: string;
  user: {
    email: string;
  };
  newValues: ActivityLogsNewValues;
}

const dateFormat = value => {
  const date = moment(value);
  return date.format("h:mm:ssA");
};

export const TimelineNewValues: React.FC<TimelineNewValuesProps> = props => {
  const { date, user, newValues } = props;

  const classes = useStyles(props);

  const newValueMFAEnabledDate =
    newValues?.mfa_enabled_date === null ? "Disabled" : "Enabled";

  return (
    <div className={classes.root}>
      <span className={classes.dot} />
      <Container>
        <div style={{ display: "flex", gap: "20px" }}>
          <div>
            <Typography className={classes.date}>{dateFormat(date)}</Typography>
          </div>
          <div style={{ alignItems: "center", gap: "20px" }}>
            <div>
              <Typography className={classes.userTypeCode}>
                {newValues?.name}
              </Typography>
            </div>
            <div>
              <Typography className={classes.userEmail}>
                {"<updated by: " + user?.email + ">"}
              </Typography>
            </div>
          </div>
        </div>
        <div style={{ marginLeft: "75px", marginTop: "20px" }}>
          <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
              <div
                style={{ alignItems: "center", display: "flex", gap: "10px" }}
              >
                <span className={classes.bullet} />
                <Typography className={classes.status}>Status:</Typography>
                <Typography>{newValueMFAEnabledDate}</Typography>
              </div>
            </CardContent>
          </Card>
        </div>
      </Container>
    </div>
  );
};

TimelineNewValues.displayName = "TimelineNewValues";

export default TimelineNewValues;
